import React, { forwardRef } from 'react';
import { formatPrice, formatDate } from '../../utils/helpers';

const InvoicePrintView = forwardRef(({ invoice }, ref) => {
  if (!invoice) return null;

  return (
    <div ref={ref} className="bg-white p-8 max-w-3xl mx-auto" style={{ fontFamily: 'Arial, sans-serif' }}>
      {/* Header */}
      <div className="flex justify-between items-start mb-8 pb-6 border-b-2 border-gray-200">
        <div>
          <h1 style={{ fontFamily: 'Georgia, serif', fontSize: '28px', color: '#D4AF37', marginBottom: '4px' }}>
            Luster Adorn
          </h1>
          <p style={{ fontSize: '12px', color: '#666' }}>Premium Imitation Jewelry</p>
          <div style={{ marginTop: '12px', fontSize: '11px', color: '#666', lineHeight: '1.6' }}>
           
            <p>Maharashtra, India</p>
            <p>Phone: +91 94211 47643</p>
            <p>Email: hello@lusteradorn.com</p>
          </div>
        </div>
        <div style={{ textAlign: 'right' }}>
          <h2 style={{ fontSize: '24px', color: '#1A1A1A', marginBottom: '8px' }}>INVOICE</h2>
          <p style={{ fontSize: '14px', color: '#D4AF37', fontWeight: 'bold' }}>{invoice.invoice_number}</p>
          <div style={{ marginTop: '12px', fontSize: '11px', color: '#666' }}>
            <p><strong>Date:</strong> {formatDate(invoice.invoice_date)}</p>
            {invoice.due_date && <p><strong>Due:</strong> {formatDate(invoice.due_date)}</p>}
          </div>
        </div>
      </div>

      {/* Customer Info */}
      <div className="mb-8">
        <h3 style={{ fontSize: '12px', color: '#999', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '8px' }}>
          Bill To
        </h3>
        <div style={{ fontSize: '13px', color: '#333', lineHeight: '1.6' }}>
          <p style={{ fontWeight: 'bold', fontSize: '14px' }}>{invoice.customer_name}</p>
          {invoice.customer_phone && <p>{invoice.customer_phone}</p>}
          {invoice.customer_email && <p>{invoice.customer_email}</p>}
          {invoice.customer_city && (
            <p>{invoice.customer_city} {invoice.customer_pincode}</p>
          )}
        </div>
      </div>

      {/* Items Table */}
      <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '24px' }}>
        <thead>
          <tr style={{ backgroundColor: '#f8f8f8' }}>
            <th style={{ textAlign: 'left', padding: '12px 8px', fontSize: '11px', color: '#666', textTransform: 'uppercase', borderBottom: '2px solid #e5e5e5' }}>#</th>
            <th style={{ textAlign: 'left', padding: '12px 8px', fontSize: '11px', color: '#666', textTransform: 'uppercase', borderBottom: '2px solid #e5e5e5' }}>Item</th>
            <th style={{ textAlign: 'center', padding: '12px 8px', fontSize: '11px', color: '#666', textTransform: 'uppercase', borderBottom: '2px solid #e5e5e5' }}>Qty</th>
            <th style={{ textAlign: 'right', padding: '12px 8px', fontSize: '11px', color: '#666', textTransform: 'uppercase', borderBottom: '2px solid #e5e5e5' }}>Rate</th>
            {invoice.items?.some(item => item.mrp) && (
              <th style={{ textAlign: 'right', padding: '12px 8px', fontSize: '11px', color: '#666', textTransform: 'uppercase', borderBottom: '2px solid #e5e5e5' }}>MRP</th>
            )}
            <th style={{ textAlign: 'right', padding: '12px 8px', fontSize: '11px', color: '#666', textTransform: 'uppercase', borderBottom: '2px solid #e5e5e5' }}>Amount</th>
          </tr>
        </thead>
        <tbody>
          {invoice.items?.map((item, index) => (
            <tr key={index} style={{ borderBottom: '1px solid #eee' }}>
              <td style={{ padding: '12px 8px', fontSize: '12px', color: '#666' }}>{index + 1}</td>
              <td style={{ padding: '12px 8px' }}>
                <p style={{ fontSize: '13px', color: '#333', fontWeight: '500' }}>{item.item_name}</p>
                {item.description && (
                  <p style={{ fontSize: '11px', color: '#999', marginTop: '2px' }}>{item.description}</p>
                )}
              </td>
              <td style={{ padding: '12px 8px', fontSize: '12px', color: '#666', textAlign: 'center' }}>{item.quantity}</td>
              <td style={{ padding: '12px 8px', fontSize: '12px', color: '#666', textAlign: 'right' }}>{formatPrice(item.unit_price)}</td>
              {invoice.items?.some(item => item.mrp) && (
                <td style={{ padding: '12px 8px', fontSize: '12px', color: '#999', textAlign: 'right', textDecoration: 'line-through' }}>
                  {item.mrp ? formatPrice(item.mrp) : '-'}
                </td>
              )}
              <td style={{ padding: '12px 8px', fontSize: '13px', color: '#333', textAlign: 'right', fontWeight: '500' }}>{formatPrice(item.total_price)}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Totals */}
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <div style={{ width: '250px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #eee' }}>
            <span style={{ fontSize: '12px', color: '#666' }}>Subtotal</span>
            <span style={{ fontSize: '12px', color: '#333' }}>{formatPrice(invoice.subtotal)}</span>
          </div>
          {invoice.tax_amount > 0 && (
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #eee' }}>
              <span style={{ fontSize: '12px', color: '#666' }}>Tax ({invoice.tax_rate}%)</span>
              <span style={{ fontSize: '12px', color: '#333' }}>{formatPrice(invoice.tax_amount)}</span>
            </div>
          )}
          {invoice.discount_amount > 0 && (
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #eee' }}>
              <span style={{ fontSize: '12px', color: '#666' }}>Discount</span>
              <span style={{ fontSize: '12px', color: '#22c55e' }}>-{formatPrice(invoice.discount_amount)}</span>
            </div>
          )}
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '12px 0', borderTop: '2px solid #1A1A1A', marginTop: '8px' }}>
            <span style={{ fontSize: '14px', color: '#1A1A1A', fontWeight: 'bold' }}>Total</span>
            <span style={{ fontSize: '16px', color: '#D4AF37', fontWeight: 'bold' }}>{formatPrice(invoice.total_amount)}</span>
          </div>
          {invoice.paid_amount > 0 && (
            <>
              <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0' }}>
                <span style={{ fontSize: '12px', color: '#666' }}>Paid</span>
                <span style={{ fontSize: '12px', color: '#22c55e' }}>{formatPrice(invoice.paid_amount)}</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', backgroundColor: invoice.balance_amount > 0 ? '#fef2f2' : '#f0fdf4', marginTop: '4px', padding: '8px' }}>
                <span style={{ fontSize: '13px', fontWeight: 'bold', color: invoice.balance_amount > 0 ? '#dc2626' : '#16a34a' }}>Balance Due</span>
                <span style={{ fontSize: '14px', fontWeight: 'bold', color: invoice.balance_amount > 0 ? '#dc2626' : '#16a34a' }}>{formatPrice(invoice.balance_amount)}</span>
              </div>
            </>
          )}
        </div>
      </div>

      {/* Notes */}
      {invoice.notes && (
        <div style={{ marginTop: '32px', padding: '16px', backgroundColor: '#f8f8f8', borderLeft: '3px solid #D4AF37' }}>
          <h4 style={{ fontSize: '11px', color: '#999', textTransform: 'uppercase', marginBottom: '4px' }}>Notes</h4>
          <p style={{ fontSize: '12px', color: '#666' }}>{invoice.notes}</p>
        </div>
      )}

      {/* Footer */}
      <div style={{ marginTop: '48px', paddingTop: '24px', borderTop: '1px solid #eee', textAlign: 'center' }}>
        <p style={{ fontSize: '11px', color: '#999', marginBottom: '4px' }}>Thank you for your business!</p>
        <p style={{ fontSize: '10px', color: '#ccc' }}>This is a computer generated invoice.</p>
      </div>

      {/* Print Styles */}
      <style>
        {`
          @media print {
            body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
            @page { margin: 0.5in; }
          }
        `}
      </style>
    </div>
  );
});

InvoicePrintView.displayName = 'InvoicePrintView';

export default InvoicePrintView;
